import { useEffect, useRef, useState } from 'react';
import { getApiErrorText } from '../../../../utils/apiResponse';

export default function useMobileResource(load, key, initialData = []) {
  const loadRef = useRef(load);
  loadRef.current = load;
  const [version, setVersion] = useState(0);
  const [state, setState] = useState({ data: initialData, loading: true, error: '' });
  useEffect(() => {
    let active = true;
    setState({ data: initialData, loading: true, error: '' });
    const request = loadRef.current;
    Promise.resolve()
      .then(request)
      .then(data => {
        if (active) setState({ data, loading: false, error: '' });
      })
      .catch(error => {
        if (active)
          setState({
            data: initialData,
            loading: false,
            error: getApiErrorText(error, 'Не вдалося завантажити дані'),
          });
      });
    return () => {
      active = false;
    };
    // key identifies the resource; data is reset on every new request.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, version]);
  return { ...state, reload: () => setVersion(value => value + 1) };
}
